export default __webpack_public_path__ + "static/team-in-road-4aa9b8d4321ef42d6f74abbe82d843f7.jpg";